const schema = () => ({
  type: "object",
  required: ["title"],
  properties: {
    title: {
      type: "string",
      title: "عنوان",
      minLength: 2,
      maxLength: 80,
    },
    code: {
      type: "string",
      title: "کد",
    },
    details: {
      title: "جزییات",
      type: "string",
      minLength: 3,
      maxLength: 240,
    },
  },
});

export default schema;
